export default __webpack_public_path__ + "static/media/modern.2599b14b.jpg";